import { render, staticRenderFns } from "./BaseSingleCheckbox.vue?vue&type=template&id=0bcbc284"
import script from "./BaseSingleCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseSingleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports